import React from "react";
import "./success.css";
import uuid from "react-uuid";

function Success() {
  let userTotalOut = parseInt(localStorage.getItem("basketTotal"));
  let userPayment = localStorage.getItem("srPayment");
  let lsShippingCostOut = parseInt(localStorage.getItem("lsShippingCost"));
  let userName = localStorage.getItem("srName");
  let userAddress = localStorage.getItem("srAddress");
  let userCity = localStorage.getItem("srCity");
  let userState = localStorage.getItem("srState");
  let userCountry = localStorage.getItem("srCountry");
  let userPincode = localStorage.getItem("srPincode");
  let userEmail = localStorage.getItem("srEmail");
  let userPhone = localStorage.getItem("srPhone");
  let newStringOut = localStorage.getItem("lsNewString");

  console.log(newStringOut, userTotalOut, lsShippingCostOut);

  function addOrder() {
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbzBRst5eEdX10jxGDUNfh4EmqPwKUSafx3A7sclwfFTRjGGSSjhNC8q6yyMY3ALvJCf/exec";
    const form = document.forms["google-sheet"];
    fetch(scriptURL, { method: "POST", body: new FormData(form) })
      .then((response) => console.log("Order received succesfully!"))
      .catch((error) => console.error("Error!", error.message));
    var myHeaders = new Headers();
    let newToken = localStorage.getItem("TOKEN");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + newToken);

    let srDate =
      new Date().toLocaleDateString("en-CA") +
      " " +
      new Date().toLocaleTimeString("en-US", { hour12: false }).slice(0, 5);
    let srOrderId = uuid();
    let srName = localStorage.getItem("srName");
    let srAddress = localStorage.getItem("srAddress");
    let srCity = localStorage.getItem("srCity");
    let srState = localStorage.getItem("srState");
    let srCountry = localStorage.getItem("srCountry");
    let srPincode = localStorage.getItem("srPincode");
    let srEmail = localStorage.getItem("srEmail");
    let srPhone = localStorage.getItem("srPhone");
    let srHeight = 20;
    let srWeight = 5;
    let srLength = 30;
    let srBreadth = 30;
    let srTotal = userTotalOut + lsShippingCostOut;

    var raw = JSON.stringify({
      order_id: srOrderId,
      order_date: srDate,
      pickup_location: "Primary",
      address: "#181 1st A Cross 2nd Phase 4th Block",
      address_2: "BSK 3rd Stage Bengaluru 560085",
      city: "Bangalore",
      billing_customer_name: srName,
      billing_last_name: "",
      billing_address: srAddress,
      billing_city: srCity,
      billing_pincode: srPincode,
      billing_state: srState,
      billing_country: srCountry,
      billing_email: srEmail,
      billing_phone: srPhone,
      shipping_is_billing: true,
      order_items: [],
      payment_method: "Prepaid",
      sub_total: srTotal,
      length: srLength,
      breadth: srBreadth,
      height: srHeight,
      weight: srWeight,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://apiv2.shiprocket.in/v1/external/orders/create/adhoc",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  }

  return (
    <div className="success">
      <form
        onSubmit={addOrder}
        className="invisible_form"
        method="POST"
        action="https://formsubmit.co/madhwapaaka@gmail.com"
        name="google-sheet"
      >
        {/* <div
          type="submit"
          class="razorpay-embed-btn"
          data-url="https://pages.razorpay.com/pl_HuAtd6wA6oRmD4/view"
          data-text="Pay Now"
          data-color="#0D7377"
          data-size="large"
        >
          {(function () {
            var d = document;
            var x = !d.getElementById("razorpay-embed-btn-js");
            if (x) {
              var s = d.createElement("script");
              s.defer = !0;
              s.id = "razorpay-embed-btn-js";
              s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
              d.body.appendChild(s);
            } else {
              var rzp = window["__rzp__"];
              rzp && rzp.init && rzp.init();
            }
          })()}
        </div> */}

        <input name="NAME" type="hidden" value={userName} />
        <input name="email" type="hidden" value={userEmail} />
        <input name="CONTACT" type="hidden" value={userPhone} />
        <input name="COUNTRY" type="hidden" value={userCountry} />
        {userCountry === "India" && (
          <input name="STATE" type="hidden" value={userState} />
        )}
        {userCountry === "India" && (
          <input name="CITY" type="hidden" value={userCity} />
        )}
        <input name="PINCODE" type="hidden" value={userPincode} />
        <input name="ADDRESS" type="hidden" value={userAddress} />
        <input type="hidden" name="YOUR-ORDER" value={newStringOut} />
        <input type="hidden" name="PAYMENT-METHOD" value={userPayment} />
        <input type="hidden" name="CART-TOTAL" value={userTotalOut} />
        <input type="hidden" name="SHIPPING-COST" value={lsShippingCostOut} />
        <input
          type="hidden"
          name="GRAND-TOTAL"
          value={parseInt(userTotalOut) + parseInt(lsShippingCostOut)}
        />
        <input
          type="hidden"
          name="_subject"
          value="Your order from Madhwa Paaka"
        />
        <input
          type="hidden"
          name="_autoresponse"
          value="Thank you for shopping with Madhwa Paaka. This is a confirmation mail that we have successfully received your order."
        />
        <input type="hidden" name="_next" value="https://www.madhwapaaka.in" />
        <input type="hidden" name="_template" value="table" />

        <i className="tick">✓</i>
        <h2>Payment Successful!</h2>
        <p>
          <br /> We have received your payment.
          <br />
          <br />
          Please click the button below to confirm your order. Once confirmed,
          you will receive an acknowledgement mail from{" "}
          <span className="fs">FormSubmit</span>.
        </p>
        <button className="success_button" type="submit">
          CONFIRM ORDER
        </button>
      </form>
    </div>
  );
}

export default Success;
